import React from 'react';

import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';

export type DialogWidth = '1' | '2' | '3' | '4' | '5';
export interface DialogState {
  isOpen: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  content: React.ReactNode | null;
  loading?: boolean;
  width?: DialogWidth;
  showCloseDialog?: boolean;
  'data-testid'?: string;
}

const initialState: DialogState = {
  isOpen: false,
  title: '',
  description: '',
  content: null,
  loading: false,
  showCloseDialog: false,
  'data-testid': '',
};

// TODO: Think about dialog system for the app.

export const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (
      state,
      action: PayloadAction<{
        title: React.ReactNode;
        description?: React.ReactNode;
        content?: React.ReactNode;
        width?: DialogWidth;
        showCloseDialog?: boolean;
        dataTestId?: string;
      }>
    ) => {
      return {
        ...state,
        isOpen: true,
        title: action.payload.title,
        width: action.payload.width,
        description: action.payload.description,
        content: action.payload.content,
        showCloseDialog: action.payload.showCloseDialog,
        loading: false,
        dataTestId: action?.payload?.dataTestId || '',
      };
    },
    closeDialog: (state) => {
      return {
        ...state,
        width: undefined,
        isOpen: false,
        title: '',
        description: '',
        content: null,
        loading: false,
        showCloseDialog: false,
        'data-testid': '',
      };
    },
    setDialogLoading: (state, action) => {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },
});

// Selectors
export const selectDialog = (state: RootState) => state.dialog;

export const selectDialogIsOpen = createSelector(
  selectDialog,
  (dialog) => dialog.isOpen
);

export const selectDialogLoading = createSelector(
  selectDialog,
  (dialog) => dialog.loading
);

export const { openDialog, closeDialog, setDialogLoading } =
  dialogSlice.actions;
export default dialogSlice.reducer;
